import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "global-capability-center": {
    id: 1,
    title: "Oracle ERP Implementation in NJ: The 2026 Complete Guide",
    category: "Oracle ERP",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "July 9, 2026",
    author: "TechProjects",
    readTime: "8 minutes",
    excerpt:
      "Explore Oracle ERP Consulting NJ with TechProjects. Learn implementation costs, timeline, best practices, and expert strategies for business success.",
    content: [
      {
        type: "heading2",
        text: "Introduction",
      },
      {
        type: "paragraph",
        text: "If you're a New Jersey business considering an Oracle ERP implementation in 2026, you're facing one of the most consequential technology decisions your company will make. Get it right, and you gain real-time visibility across finance, supply chain, and HR. Get it wrong, and you're looking at cost overruns, delayed go-lives, and years of workarounds.",
    },
    {
        type: "paragraph",
        text: 'At TechProjects, we have led <a href="https://techprojects.com/contact" class="text-blue-600 hover:text-blue-800">Oracle ERP consulting NJ</a> businesses in healthcare, supply chain, financial services, and the public sector for over 15 years. This guide gives you the honest picture. What Oracle ERP can do, how to plan the implementation, and how to avoid the mistakes that derail most projects.',},
    {
        type: "heading2",
        text: "What Is Oracle ERP? and Why Do NJ Businesses Choose It?",
      },
      {
        type: "paragraph",
        text: "Oracle ERP (Enterprise Resource Planning) is a suite of integrated applications that manages core business functions from a single platform. For mid-market and enterprise NJ organizations, Oracle offers three key advantages."
    },
    {
        type: "bulletList",
        items: [
          "Unmatched depth in finance, procurement, and supply chain modules",
          "Proven scalability from 50-user SMBs to global enterprises",
          "Strong government and regulated industry compliance frameworks",
          "Deep integration with Oracle Cloud, AI automation, and analytics",
         
        ],
      },
      
      {
        type: "heading2",
        text: "The 6 Phases of an Oracle ERP Implementation",
      },
      {
        type: "paragraph",
        text: "Every successful Oracle implementation at TechProjects follows this proven framework:",
      },
      {
        type: "bulletList",
        items: [
          'Discovery & Requirements (Weeks 1–3): Map current processes, identify gaps, define success criteria.',
          "Solution Design (Weeks 4–8): Configure Oracle modules to match your business workflows not the reverse.",
          "Build & Configuration (Weeks 9–16): Technical setup, custom development, data mapping, integration design.",
          "Testing (Weeks 17–22): Unit testing, integration testing, User Acceptance Testing (UAT) with real users.",
          "Training & Change Management (Weeks 20–24): Your people are the #1 go-live risk. This phase is non-negotiable.",
          "Go-Live & Hyper-Care (Weeks 24–28): Controlled launch with TechProjects support team on standby.",
         
        ],
      },
      
      {
        type: "heading2",
        text: "How Much Does Oracle ERP Implementation Cost in NJ?",
      },
      {
        type: "paragraph",
        text: "Cost depends on scope, modules, and customization. General ranges for NJ mid-market businesses include:",
      },
      {
        type: "bulletList",
        items: [
          "Small implementation (1–2 modules, fewer than 100 users): $80,000–$250,000",
          "Mid-range implementation (3–5 modules, 100–500 users): $250,000–$750,000",
          "Enterprise implementation (full suite, 500+ users): $750,000–$2M+",
        ],
      },
      {
        type: "paragraph",
        text: "TechProjects provides fixed-scope implementation packages to eliminate surprise cost overruns, something many large consulting firms rarely offer.",
      },
      {
        type: "heading2",
        text: "3 Oracle ERP Implementation Mistakes NJ Companies Make",
      },
      {
        type: "paragraph",
        text: "After 15 years and dozens of NJ implementations, here are the failure patterns we fix most often:",
      },
      {
        type: "bulletList",
        items: [
          "Under-investing in change management: Technology accounts for only 30% of success. User adoption makes up the remaining 70%.",
          "Over-customizing at go-live: Start with Oracle's standard workflows and customize only after fully understanding the system.",
          "Choosing a generalist consulting firm: Oracle implementation is a specialized discipline. General IT firms often lack the expertise needed to manage Oracle licensing, modules, and upgrade paths effectively.",
        ],
      },
      {
        type: "heading3",
        text: "Why TechProjects Is NJ's Preferred Oracle ERP Consulting Partner",
      },
      {
        type: "bulletList",
        items: [
          "GSA Schedule 70 certified, serving both commercial and government clients",
          "Minority and women-owned: Certified NJ Disadvantaged Business, WBE, and MBE",
          "15+ years of experience and $19.7M in revenue with Oracle consulting as a core practice",
          "Fixed-scope pricing with no surprise invoices",
          "Local New Jersey team supported by global delivery capabilities for greater cost efficiency",
        ],
      },
      
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "Oracle ERP implementation in New Jersey doesn't have to be a gamble. With the right partner, the right phased approach, and an experienced implementation team, your ERP investment becomes a competitive advantage. TechProjects has delivered Oracle implementations on time and within budget for organizations across healthcare, supply chain, finance, and government for more than 15 years.",
      },
      {
        type: "paragraph",
        text: "Ready to explore what Oracle implementation looks like for your business? Contact TechProjects for a free discovery call. We'll assess your requirements, estimate project scope, and provide an honest implementation timeline without any obligation.",
      },
      {
        type: "heading2",
        text: "FAQS :",
      },
      {
        type: "heading3",
        text: "1. Why choose TechProjects for Oracle ERP consulting in NJ? :",
      },
      {
        type: "paragraph",
        text: "TechProjects is a trusted Oracle ERP consulting company in NJ with over 15 years of implementation experience. Our certified consultants help businesses plan, deploy, customize, and optimize Oracle ERP solutions with fixed-scope pricing, industry best practices, and end-to-end implementation support.",
      },
      {
        type: "heading3",
        text: "2. How much does Oracle ERP implementation cost with TechProjects in New Jersey?",
      },
      {
        type: "paragraph",
        text: "The cost of Oracle ERP implementation with TechProjects depends on your business size, modules, integrations, and customization needs. Most New Jersey businesses invest between $80,000 and $2 million+. TechProjects provides transparent project estimates and fixed-scope implementation plans to help control costs.",
      },
      {
        type: "heading3",
        text: "3. How long does Oracle ERP implementation take with TechProjects?",
      },
      {
        type: "paragraph",
        text: "A typical Oracle ERP implementation by TechProjects takes 4–8 months for mid-sized organizations. Larger enterprise projects may require 9–12 months. Our structured implementation methodology helps reduce project risks, accelerate deployment, and ensure a successful go-live.",
      },
      {
        type: "heading3",
        text: "4. What Oracle ERP implementation services does TechProjects offer in New Jersey?",
      },
      {
        type: "paragraph",
        text: "TechProjects provides comprehensive Oracle ERP consulting services in NJ, including business process assessment, Oracle Cloud ERP implementation, Oracle EBS support, ERP migration, system integration, data migration, user training, post-go-live support, and ongoing application optimization for businesses across New Jersey.",
      },
      {
        type: "heading3",
        text: "5. What makes TechProjects one of the best Oracle ERP consulting companies in NJ?",
      },
      {
        type: "paragraph",
        text: "TechProjects combines deep Oracle expertise, certified implementation consultants, industry-specific experience, transparent pricing, and dedicated post-implementation support. We help New Jersey businesses successfully implement Oracle ERP solutions that improve operational efficiency, financial visibility, compliance, and long-term business growth.",
      },

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  useEffect(() => {
    const fetchMetaData = async () => {
      const data = await getPagesBySlug(slug);
      setMetaData(data?.meta || {});
    };
    fetchMetaData();
  }, [slug]);
  // slug = useParams();
  console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["global-capability-center"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Discover how Global Capability Centers (GCCs) are transforming businesses through innovation, AI, cybersecurity, and digital transformation. Learn benefits, trends, and future opportunities.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
